import { Items } from "@pdfking/tfunc"

import { is_mapping } from "./is_mapping"
import { ordered_object } from "./ordered_object"
import { to_array } from "./to_array"

/**
 * Maps function over iterable.
 *
 * For objects, returns mapped object. For arrays, returns mapped array.
 * Function receives (value, key/index).
 *
 * @param f - Mapping function
 * @param iterable - Array, object, or primitive to map
 * @returns Mapped result matching input type
 *
 * @example
 * ```ts
 * import { map } from "@pdfking/rfunc"
 *
 * map(v => v + 2, [1, 2, 3]) // [3, 4, 5]
 * map(v => v + 2, { a: 3, b: 5 }) // { a: 5, b: 7 }
 * ```
 */
export const map = (f, iterable) => {
  // we want to return a new object if iterable is an object

  if (is_mapping(iterable)) {
    return ordered_object(Items(iterable).map(a => [a[0], f(a[1], a[0])]))
  }
  return to_array(iterable).map(f)
}
